/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ActivityTranslationResponse } from '../../models/activity-translation-response';

export interface GetActivityTranslation$Params {
  id: number;
  fromCulture: string;
  toCulture: string;
}

export function getActivityTranslation(http: HttpClient, rootUrl: string, params: GetActivityTranslation$Params, context?: HttpContext): Observable<StrictHttpResponse<ActivityTranslationResponse>> {
  const rb = new RequestBuilder(rootUrl, getActivityTranslation.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('fromCulture', params.fromCulture, {});
    rb.query('toCulture', params.toCulture, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ActivityTranslationResponse>;
    })
  );
}

getActivityTranslation.PATH = '/api/activities/{id}/translation';
